import app from '@/app';

/* @ngInject */
const resource = abstractResource => abstractResource('organization');

app.factory('Organization', resource);
